module.exports = __webpack_public_path__ + "static/Shoppable-Recipes-4bac501f5f56ce3882c9fc586750770b.jpg";